






































import {Component, Prop, Watch, Provide, Vue} from 'vue-property-decorator'
import {$, Helper} from 'simpli-web-sdk'
import {CargaTransfolha} from '@/model/resource/CargaTransfolha'
import {InputCargaTransfolhaSchema} from '@/schema/resource/CargaTransfolha/InputCargaTransfolhaSchema'

@Component
export default class PersistCargaTransfolhaView extends Vue {
  @Prop() id?: string

  @Provide('validator') validator = this.$validator

  schema = new InputCargaTransfolhaSchema()
  cargaTransfolha = new CargaTransfolha()

  async created() {
    this.populateResource()
    await this.populate()
  }

  populateResource() {
    this.schema.collectionCarga.listCarga()
  }

  async populate() {
    const id = Number(this.id) || null

    if (id) {
      await this.cargaTransfolha.getCargaTransfolha(id)
    }

    $.await.done('getCargaTransfolha')
  }

  async persist() {
    const isValid = await this.validator.validateAll()

    if (!isValid) {
      Helper.abort('system.error.validation')
    }

    await this.cargaTransfolha.persistCargaTransfolha()
    await Helper.successAndPush(
      'system.success.persist',
      '/carga-transfolha/list'
    )
  }
}
